<template>
    <div>
        <competition-list-link :listLayout="listLayout" :competitionData="competitionList"
                               :paginationData="filterSet.page"
                               v-if="competitionList.length > 0"></competition-list-link>
        <competition-empty-link :emptyLayout="emptyLayout" v-else></competition-empty-link>
    </div>
</template>

<script>
import CompetitionListLink from "@/components/competition/CompetitionListLink";
import CompetitionEmptyLink from "@/components/competition/CompetitionEmptyLink";
import CompetitionFilterLink from "@/components/competition/CompetitionFilterLink";
import PaginationLink from "@/components/competition/PaginationLink";
import competitionUtil from "@/components/competition/competitionUtil";
import alertMixins from "@/mixins/alertMixins";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import DeleteClass from "@/mixins/deleteClass";

const {filterConfig} = competitionUtil;

export default {
    name: "CompetitionListComponent",
    mixins: [competitionUtil, alertMixins, filterMixins, listMixins],
    components: {
        CompetitionListLink,
        CompetitionEmptyLink,
        CompetitionFilterLink,
        PaginationLink
    },
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setSort: this.setSort,
            setCompetitionListData: this.setData,
        }
    },
    props: {
        competitionType: '',
        competitionKey: '',
        selectArray: {
            type: Array,
            default: () => {
                return []
            }
        },
        memberKey: ''
    },
    data() {
        return {
            listLayout: '',
            filterLayout: '',
            emptyLayout: '',
            paginationLayout: '',
            getFunc: '',
            listApiParamSet: {},
            pageRow: '',
            getMemberKeyName: 'no',
            getKeyName: 'cid',
            selectFilterKeyName: 'i_idx',
            reList: [],
            deleteFunc: '',
            deleteApiParamSet: {},
            deleteSuccessType: 1,
            deleteErrorTypes: {},
            deleteClass: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
        EventBus.$on('voteItem', this.voteItemConfirm)
        EventBus.$on('deleteCompetition', this.runDelete)
    },
    beforeDestroy() {
        EventBus.$off('voteItem')
        EventBus.$off('deleteCompetition')
    },
    destroyed() {
    },
    computed: {
        competitionList() {
            return this.reList
        }
    },
    methods: {
        initConfig() {
            let competitionConfig = this.returnCompetitionConfig(this.competitionType);
            this.listLayout = competitionConfig.listLayout;
            this.paginationLayout = competitionConfig.paginationLayout;
            this.filterLayout = competitionConfig.filterLayout;
            this.emptyLayout = competitionConfig.emptyLayout;
            this.getFunc = competitionConfig.getFunc;
            this.listApiParamSet = competitionConfig.listApiParamSet;
            this.pageRow = competitionConfig.pageRow;
            this.getMemberKeyName = competitionConfig.getMemberKeyName;
            this.getKeyName = competitionConfig.getKeyName;
            this.selectFilterKeyName = competitionConfig.selectFilterKeyName;

            if (competitionConfig.pageRow && competitionConfig.pageRow != this.filterSet.page.size) {
                this.pageRow = competitionConfig.pageRow;
                this.filterSet.page.size = competitionConfig.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            let params = JSON.parse(JSON.stringify(this.listApiParamSet));
            if (!util.isEmpty(this.competitionKey) && !util.isEmpty(this.getKeyName)) {
                params[this.getKeyName] = this.competitionKey
            } else if (!util.isEmpty(this.competitionKey)) {
                params.cid = this.competitionKey
            }
            if (!util.isEmpty(this.memberKey) && !util.isEmpty(this.getMemberKeyName)) {
                params[this.getMemberKeyName] = this.memberKey
            } else if (!util.isEmpty(this.memberKey)) {
                params.no = this.memberKey
            }

            let listOptions = {
                url: this.$api.$competition[this.getFunc],
                defaultParams: params,
            }
            this.sortOptions = competitionConfig.sortOptions
            this.setSortOptions(this.sortOptions)
            this.initList('api', listOptions);

            this.initDeleteClass();

        },
        initDeleteClass() {
            let options = {
                func: this.$api.$competition[this.deleteFunc],
                apiParamSet: this.deleteApiParamSet,
                keyName: this.deleteKayName,
                successType: this.deleteSuccessType,
                errorTypes: this.deleteErrorTypes,
                afterFunc: this.deleteAfterFunc,
            }
            this.deleteClass = new DeleteClass(options);
        },
        setData(key, value) {
            this[key] = value
        },
        voteItemConfirm(ci_idx) {
            this.createConfirm({
                content: this.$t('confirm_vote'),
                confirm: () => {
                    this.voteItem(ci_idx)
                },
                cancel: () => {

                }
            })
        },
        voteItem(ci_idx) {
            let params = {
                ci_idx: ci_idx
            }
            try {
                this.$api.$competition.voteItem(params).then(res => res.Data.Result).then(res => {
                    let result = this.returnVoteType(res.Info.type)
                    if (result === true) {
                        this.getList()
                        this.createAlert({
                            content: this.$t('vote_done'),
                            hide: () => {
                            }
                        })
                    } else {
                        this.createAlert({
                            content: result,
                            btnText: this.$t('yes'),
                            hide: () => {

                            }
                        })
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
        returnVoteType(type) {
            switch (type) {
                case 1 : {
                    return true
                }
                case -841 : {
                    return this.$t('vote_err_date')
                }
                case -842 : {
                    return this.$t('vote_err_over')
                }
                case -843 : {
                    return this.$t('vote_err_already')
                }
                case -844 : {
                    return this.$t('vote_err_fail')
                }
                default : {
                    return this.$t('vote_err_fail2')
                }
            }
        },
        //응모 아이템 삭제
        deleteAfterFunc() {
            this.createAlert({
                content: this.$t('cancel_success_msg'),
                hide: () => {
                    this.getList()
                }
            })
        },
        runDelete(key) {
            let params = {ci_idx: key}
            try {
                this.$api.$competition.deleteCompetitionEntryItem(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type === 1) {
                        this.deleteAfterFunc()
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
    },
    watch: {
        'List': {
            deep: true,
            handler: function (val, oldVal) {
                this.reList = [...this.List]
                if (!util.isEmpty(this.selectArray)) {
                    this.reList = this.List.filter(data => {
                        let keyName = util.isEmpty(this.selectFilterKeyName) ? 'i_idx' : this.selectFilterKeyName;
                        return this.selectArray.indexOf(data[keyName]) < 0
                    });
                }

            }
        }
    },
}
</script>

<style scoped>

</style>
